export const burger = () => {
    const wrapper = document.querySelector('.header') as HTMLElement
    const button = wrapper?.querySelector('.header__burger') as HTMLButtonElement
    const nav = wrapper?.querySelector('.header__nav') as HTMLDivElement

    if (!button || !nav) return

    button.addEventListener('click', () => {
        button.querySelector('.icon')?.classList.toggle('active')
        nav.classList.toggle('active')
        document.body.classList.toggle('no-scroll')
    })
}
